<template>
    <div class="system-dic-dialog-container">
        <el-dialog :title="title" :visible.sync="isShowDialog" width="769px">
            <el-form ref="dicDialogFormRef" :model="formData" v-loading="isLoading" :rules="rules" size="small"
                label-width="90px" class="demo-ruleForm">
                <el-row :gutter="35">
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
                        <el-form-item label="字典名称" prop="DictName">
                            <el-input v-model="formData.DictName" placeholder="请输入字典名称" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
                        <el-form-item label="标识符" prop="DictCode">
                            <el-input v-model="formData.DictCode" placeholder="请输入标识符" clearable></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                        <el-row :gutter="35" v-for="(v, k) in list"  :key="k">
                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
                                <el-form-item>
                                    <template #label>
                                        <el-button type="primary" @click="addRow" icon="el-icon-plus" circle
                                            v-if="k === 0"></el-button>
                                        <el-button type="danger" @click="delRow(k)" icon="el-icon-delete" circle
                                            v-else></el-button>
                                        <span class="ml10">名称</span>
                                    </template>
                                    <el-input v-model="v.ItemText" style="width: 100%" placeholder="请输入名称"> </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
                                <el-form-item label="项值">
                                    <el-input v-model="v.ItemValue" style="width: 100%" placeholder="请输入项值"> </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                        <el-form-item label="字典描述">
                            <el-input v-model="formData.Remark" type="" placeholder="请输入字典描述"
                                maxlength="150"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="onCancel" size="default">取 消</el-button>
                    <el-button :loading="btnLoading" type="primary" @click="onSubmit" size="default">保存</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { GetSysDictByCode, UpdateSysDic } from "@/api/SysDictionary/SysDictionary"
export default {
    data() {
        return {
            title: "",
            isShowDialog: false,
            isLoading: false,
            btnLoading: false,
            formData: {
                DictName: '',
                DictCode: ''
            },
            list: [{}],
            rules: {
                DictName: [
                    { required: true, message: '请输入字典名称', trigger: 'blur' }
                ],
                DictCode: [
                    { required: true, message: '请输入字典标识', trigger: 'blur' }
                ],
            }
        };
    },
    computed: {},
    methods: {
        openDialog(e, key) {
            this.list = [{}]
            this.formData = e
            this.resetForm('')
            let dic = {
                'edit': '编辑',
                'add': '新增',
            }
            this.title = dic[key]
            key == 'edit' && this.HttpQueryDicList({ code: e.DictCode })
            this.isShowDialog = true
        },
        resetForm(formName) {
            this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
        },
        onCancel() {
            this.isShowDialog = false
        },
        addRow() {
            let item = this.list.find((o) => !o.ItemText || !o.ItemValue)
            if (item) {
                this.$message({
                    message: '请检查数据是否填写完整',
                    type: 'error'
                });
                return
            }
            this.list.push({
                ItemText: '',
                ItemValue: ''
            })
        },
        delRow(index) {
            this.list.splice(index, 1)
        },
        onSubmit() {
            this.btnLoading = true
            let that = this
            this.$refs.dicDialogFormRef.validate((valid) => {
                this.btnLoading = false
                if (valid) {
                    let item = this.list.find((o) => !o.ItemText || !o.ItemValue)
                    console.log(item);
                    if (item) {
                        that.$message({
                            message: '请检查数据是否填写完整',
                            type: 'error'
                        });
                        return
                    }
                    that.submit()
                } else {
                    console.log('error submit!!', valid);
                    return false;
                }
            });
        },
        submit() {
            let { DictCode, DictName, Remark } = this.formData
            let list = JSON.parse(JSON.stringify(this.list))
            list.map((o) => {
                o.DictCode = DictCode
                o.DictName = DictName
                o.Remark = Remark
                return o
            })
            console.log({ List: list });

            this.HttpUpdateSysDic({ List: list })
        },
        async HttpQueryDicList(param) {
            this.isLoading = true
            const response = await GetSysDictByCode(param);
            this.isLoading = false
            let res = response.data;
            if (res.status == 200) {
                let raw = res.response || [];
                this.list = raw
            } else {
                this.$message({
                    message: res.msg,
                    type: 'error'
                });
            }
        },
        async HttpUpdateSysDic(param) {
            this.btnLoading = true
            const response = await UpdateSysDic(param)
            this.btnLoading = false
            let res = response.data
            if (res.status == 200) {
                this.isShowDialog = false
                this.$emit('refresh')
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: res.msg,
                    type: 'error'
                });
            }
        }
    },
};
</script>